import styled from "styled-components";
import {Select, Row, Table, Col, Input} from "antd";

export const TableContainer = styled(Table)`
    @media (max-width: 768px) {
        .ant-table-cell {
            font-size: 11px;
            padding: 1px;
        }
        .ant-tag {
            font-size: 10px;
            padding: 1px;
            margin: 0px;
        }
        .ant-btn-icon-only {
            font-size: 2px;
            width: 0px;
            height: 0px;
        }
        .daSDBY {
            margin: 0px;
        }
        .evcfTQ {
            margin: 0px;
        }
        .ant-table.ant-table-small .ant-table-tbody > tr > td,
        .ant-table.ant-table-small .ant-table-thead > tr > th {
            padding: 3px 3px;
        }
    }
`;
export const TableText = styled.p`
    font-size: 12px;
`
export const DedicationTitle = styled.h4`
    width: ${props => props.width + "px"};
    margin-bottom: 0px;
`